<template>
  <div class="pop">
    <div class="abs popCont">
      <button class="abs popClose" @click="closePop"></button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { closePop } from '@/utils/common.js';

export default {
  methods: {
    closePop,
  }
}
</script>

<style scpoed>
.pop{ position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.85); z-index: 10;}
.popCont{ top: 50%; left: 50%; transform: translate(-50%, -50%);}
.popClose{ top: 39px; right: -5px; width: 70px; height: 70px; background: url(@images/popClose.png) no-repeat 0 0; z-index: 1;}
</style>